export default __webpack_public_path__ + "static/media/website_cover_PCimageZh.92411c1c.jpg";